import type { Ref, Update } from '@wix/thunderbolt-types'
import type { Component } from '@wix/thunderbolt-becky-types'
import type { Unref } from '@wix/thunderbolt-catharsis'
import type { RawModel } from '../../../../../types'
import { getDataItemRefsWithOverrides } from '../../../dataConsumption'
import type { DataRefsForPresetResolving, DataItemWithDependencies } from '../../../types'
import type { DependenciesData } from '../types'

export type ConsumptionDataNode<TData, TDependencies, TRefConsumptionDependencies> = {
	getDependencies?: (data: TData) => TDependencies
	updateDependencies?: (data: {
		update: Update<void>
		inflatedComponent: Component
		dependencies: TDependencies
		id: string
	}) => void
	toViewItem?: (data: {
		id: string
		value: Unref<TRefConsumptionDependencies>
		rawModel: RawModel
		aspect: string
	}) => any
}

export const createConsumptionDataNode = <TData, TDependencies, TRefConsumptionDependencies>(
	obj: ConsumptionDataNode<TData, TDependencies, TRefConsumptionDependencies>
) => obj

export const getDataRefsForPresetResolving = (
	{
		templateComponent,
		queryName,
		createRefInTemplateNamespace,
		getOverrideDataRefs,
		getLeafsOverridesMapsRefs,
		getParentRefCompResolvedPresets,
	}: DependenciesData,
	templateDataId?: string
): DataRefsForPresetResolving => {
	const refArraysWithOverrides = getDataItemRefsWithOverrides({
		templateComponent,
		queryName,
		createRefInTemplateNamespace,
		getOverrideDataRefs,
		templateDataId,
	}) as Array<Ref<DataItemWithDependencies>>

	const leafsOverridesMaps = getLeafsOverridesMapsRefs(templateComponent.id, queryName)
	const parentRefCompResolvedPresets = getParentRefCompResolvedPresets()

	return {
		refArraysWithOverrides,
		leafsOverridesMaps,
		parentRefCompResolvedPresets,
	}
}
